/**
 * soul-variant-helps.js
 * - Updates "Helps with" pills on the product page when the selected variant changes.
 * - Updates the badge label on product cards to show the first helps_with tag.
 * Data source: soul-variant-metafields.json (URL injected via <meta name="soul-metafields-url">).
 */
(function () {
  if (window.__soulVariantHelpsInit) return;
  window.__soulVariantHelpsInit = true;

  var cache = null;

  function getJsonUrl() {
    var meta = document.querySelector('meta[name="soul-metafields-url"]');
    return meta ? meta.getAttribute('content') : null;
  }

  function buildTitleVariantIndex(data) {
    if (!data || !data.by_variant_id || data._by_title_variant) return;
    var idx = {};
    Object.keys(data.by_variant_id).forEach(function (key) {
      var e = data.by_variant_id[key];
      if (e.product_title && e.variant_name) {
        idx[e.product_title + '::' + e.variant_name] = e;
      }
    });
    data._by_title_variant = idx;
  }

  function loadData() {
    if (cache) return Promise.resolve(cache);
    var url = getJsonUrl();
    if (!url) return Promise.resolve(null);
    return fetch(url)
      .then(function (res) { return res.json(); })
      .then(function (data) {
        buildTitleVariantIndex(data);
        cache = data;
        return data;
      });
  }

  function getSelectedOptionText() {
    var checked = document.querySelector('.product-form__input--pill input[type="radio"]:checked');
    if (!checked) return null;
    var id = (checked.id || '').trim();
    var label = id && document.querySelector('label[for="' + id + '"]');
    return label ? label.textContent.trim() : null;
  }

  // ── Product page: update gallery badge with first helps_with tag ─────────
  function updateGalleryBadge(helpsWith) {
    var badge = document.querySelector('.product__media-badge');
    if (!badge) return;
    if (helpsWith && helpsWith.length) {
      badge.textContent = helpsWith[0].trim();
    }
  }

  // ── Product page: update "Helps with" pills ──────────────────────────────
  function updatePills(helpsWith) {
    document.querySelectorAll('.product-metafields-soul[data-metafields-url]').forEach(function (container) {
      var row = container.querySelector('.product-metafields-soul__helps');
      var pillsEl = container.querySelector('.product-metafields-soul__pills');
      if (!row || !pillsEl) return;

      if (helpsWith && helpsWith.length) {
        pillsEl.innerHTML = helpsWith
          .map(function (item) {
            return '<span class="product-metafields-soul__pill">' + item.trim() + '</span>';
          })
          .join('');
        row.hidden = false;
      } else {
        row.hidden = true;
      }
    });
  }

  // ── Product page: update dosage level text + icon ───────────────────────
  function updateDosage(variantId, data, variantName) {
    document.querySelectorAll('.product-metafields-soul[data-metafields-url]').forEach(function (container) {
      // 1. Look up by variant_id
      var entry = data && data.by_variant_id && data.by_variant_id[String(variantId)];
      // 2. Fall back to product_id
      if (!entry) {
        var productId = container.dataset.productId;
        entry = productId && data.by_product_id && data.by_product_id[String(productId)];
      }
      // 3. Fall back to product title + variant name
      if (!entry && variantName) {
        var productTitle = container.dataset.productTitle;
        entry = productTitle && data._by_title_variant && data._by_title_variant[productTitle + '::' + variantName];
      }

      var productHandle = container.dataset.productHandle;
      if (productHandle === 'cbd-gummies' || productHandle === 'cbd-oil-drops') return;

      var doseRow  = container.querySelector('.product-metafields-soul__dose-row');
      var dosageEl = container.querySelector('.product-metafields-soul__dosage');
      if (!dosageEl) return;

      var textEl = dosageEl.querySelector('.product-metafields-soul__dosage-text');
      var imgEl  = dosageEl.querySelector('.product-metafields-soul__dosage-icon');
      var thcEl  = dosageEl.querySelector('.product-metafields-soul__dosage-thc');

      var dosageLevel = entry && entry.dosage_level;
      var doseLabel   = entry && entry.dose;
      if (doseLabel === 'NA' || doseLabel === 'na') doseLabel = '';

      if (doseLabel || dosageLevel) {
        if (doseRow) doseRow.hidden = false;
        if (textEl) textEl.textContent = doseLabel || dosageLevel || '';
        if (dosageLevel && imgEl) {
          // Map "low dose" → data-low-dose-img, etc.
          var imgSrc = container.getAttribute('data-' + dosageLevel.replace(/ /g, '-') + '-img');
          if (imgSrc) {
            imgEl.src = imgSrc;
            imgEl.alt = dosageLevel;
            imgEl.hidden = false;
          }
        }
        if (thcEl && entry.dose_thc_mg != null && entry.dose_thc_mg !== 0) {
          thcEl.textContent = entry.dose_thc_mg + 'mg THC';
          thcEl.hidden = false;
        }
      }
    });
  }

  // ── Product page: update flavor text ────────────────────────────────────
  function updateFlavor(variantId, data, variantName) {
    document.querySelectorAll('.product-metafields-soul[data-metafields-url]').forEach(function (container) {
      var entry = data && data.by_variant_id && data.by_variant_id[String(variantId)];
      if (!entry) {
        var productId = container.dataset.productId;
        entry = productId && data.by_product_id && data.by_product_id[String(productId)];
      }
      if (!entry && variantName) {
        var productTitle = container.dataset.productTitle;
        entry = productTitle && data._by_title_variant && data._by_title_variant[productTitle + '::' + variantName];
      }

      var flavorRow  = container.querySelector('.product-metafields-soul__flavor-row');
      var flavorText = container.querySelector('.product-metafields-soul__flavor-text');
      if (!flavorRow || !flavorText) return;

      var flavor = entry && entry.flavor;
      if (flavor) {
        flavorText.textContent = flavor;
        flavorRow.hidden = false;
      } else {
        flavorRow.hidden = true;
      }
    });
  }

  // ── Not Magic Just Science cards: update [data-nms-thc-mg] / [data-nms-cbd-mg] spans ──
  function updateScienceCards(variantId, data) {
    var entry = data && data.by_variant_id && data.by_variant_id[String(variantId)];
    if (!entry) return;
    document.querySelectorAll('.not-magic-science-soul__cards').forEach(function (cards) {
      if (entry.dose_thc_mg != null && entry.dose_thc_mg !== 0) {
        cards.querySelectorAll('[data-nms-thc-mg]').forEach(function (el) {
          el.textContent = entry.dose_thc_mg;
        });
      }
      if (entry.dose_cbd_mg != null && entry.dose_cbd_mg !== 0) {
        cards.querySelectorAll('[data-nms-cbd-mg]').forEach(function (el) {
          el.textContent = entry.dose_cbd_mg;
        });
      }
    });
  }

  function applyVariant(variantId, variantName) {
    loadData().then(function (data) {
      if (!data) return;
      // Primary lookup by variant ID; fallback to first container's product title + variant name
      var entry = data.by_variant_id && data.by_variant_id[String(variantId)];
      if (!entry && variantName) {
        var container = document.querySelector('.product-metafields-soul[data-metafields-url]');
        if (container) {
          var productTitle = container.dataset.productTitle;
          entry = productTitle && data._by_title_variant && data._by_title_variant[productTitle + '::' + variantName];
        }
      }
      if (entry && entry.helps_with) {
        updatePills(entry.helps_with);
        updateGalleryBadge(entry.helps_with);
      }
      updateDosage(variantId, data, variantName);
      updateFlavor(variantId, data, variantName);
      updateScienceCards(variantId, data);
    });
  }

  // Intercept history.replaceState — product-info.js calls this on every variant switch
  var _replaceState = history.replaceState.bind(history);
  history.replaceState = function (state, title, url) {
    _replaceState(state, title, url);
    if (url) {
      try {
        var variantId = new URL(url, window.location.origin).searchParams.get('variant');
        if (variantId) applyVariant(variantId, getSelectedOptionText());
      } catch (e) {}
    }
  };

  // ── Product cards: update badge from product_badges ───────────────────────
  function updateCardBadges(data) {
    if (!data || !data.product_badges) return;
    document.querySelectorAll('[data-product-handle]').forEach(function (card) {
      var handle = card.dataset.productHandle;
      if (!handle) return;
      var badge = data.product_badges[handle];
      if (!badge) return;
      var badgeEl = card.querySelector('.featured-product-tabs__badge')
        || card.querySelector('[class*="__badge"]');
      if (badgeEl) badgeEl.textContent = badge;
    });
  }

  // ── Product cards: update dosage level text + icon ───────────────────────
  function updateCardStrength(data) {
    document.querySelectorAll('[data-first-variant-id]').forEach(function (card) {
      var variantId = card.dataset.firstVariantId;
      var handle    = card.dataset.productHandle;
      if (!variantId && !handle) return;

      var entry = data && data.by_variant_id && data.by_variant_id[String(variantId)];

      var strengthEl = card.querySelector('[data-fpt-strength]');
      if (!strengthEl) return;

      var textEl = strengthEl.querySelector('[data-fpt-strength-text]');
      var imgEl  = strengthEl.querySelector('[data-fpt-strength-icon] img');

      // CBD products: check handle-based lookup first (covers products missing from by_variant_id)
      var handleCbdLabel = data.product_cbd_dose_by_handle && handle && data.product_cbd_dose_by_handle[handle];
      if (handleCbdLabel) {
        if (textEl) textEl.textContent = handleCbdLabel;
        // Use the dosage level icon from the variant entry if available, else default to medium
        var dosageLevelForIcon = (entry && entry.dosage_level) || 'medium dose';
        if (imgEl) {
          var cbdImgSrc = strengthEl.getAttribute('data-' + dosageLevelForIcon.replace(/ /g, '-') + '-img');
          if (cbdImgSrc) { imgEl.src = cbdImgSrc; imgEl.alt = dosageLevelForIcon; }
        }
        return;
      }

      if (!entry) return;

      var dosageLevel = entry.dosage_level; // e.g. "low dose", "medium dose", "high dose"
      if (!dosageLevel) return;

      if (textEl) {
        textEl.textContent = dosageLevel.charAt(0).toUpperCase() + dosageLevel.slice(1);
      }
      if (imgEl) {
        var imgSrc = strengthEl.getAttribute('data-' + dosageLevel.replace(/ /g, '-') + '-img');
        if (imgSrc) {
          imgEl.src = imgSrc;
          imgEl.alt = dosageLevel;
        }
      }
    });
  }

  // ── Cart drawer: update THC/CBD dosage per line item ────────────────────
  function updateCartItemDosage(data) {
    document.querySelectorAll('.cart-item__dosage[data-variant-id]:not([data-populated])').forEach(function (el) {
      var variantId = el.dataset.variantId;
      var entry = data.by_variant_id && data.by_variant_id[variantId];
      el.dataset.populated = '1';
      if (!entry) return;
      var parts = [];
      if (entry.dose_thc_mg != null && entry.dose_thc_mg !== 0) parts.push(entry.dose_thc_mg + 'mg THC');
      if (entry.dose_cbd_mg != null && entry.dose_cbd_mg !== 0) parts.push(entry.dose_cbd_mg + 'mg CBD');
      if (parts.length) {
        el.textContent = parts.join(' · ');
        el.hidden = false;
      }
    });
  }

  function initCartDosageObserver(data) {
    var cartDrawer = document.getElementById('CartDrawer');
    if (!cartDrawer || typeof MutationObserver === 'undefined') return;
    new MutationObserver(function () {
      updateCartItemDosage(data);
    }).observe(cartDrawer, { childList: true, subtree: true });
  }

  // ── Init on DOMContentLoaded ─────────────────────────────────────────────
  document.addEventListener('DOMContentLoaded', function () {
    loadData().then(function (data) {
      if (!data) return;

      // Update card badges and strength from product_badges JSON
      updateCardBadges(data);
      updateCardStrength(data);
      updateCartItemDosage(data);
      initCartDosageObserver(data);

      // Update pills and dose for the initial variant on a product page.
      // Prefer ?variant= URL param; fall back to data-variant-id set by Liquid.
      var heroContainer = document.querySelector('.product-metafields-soul[data-variant-id]');
      var variantId = new URLSearchParams(window.location.search).get('variant');
      if (!variantId && heroContainer) variantId = heroContainer.dataset.variantId;
      var variantName = heroContainer ? heroContainer.dataset.variantName : null;
      if (variantId) {
        var entry = data.by_variant_id && data.by_variant_id[String(variantId)];
        if (!entry && variantName && heroContainer) {
          var productTitle = heroContainer.dataset.productTitle;
          entry = productTitle && data._by_title_variant && data._by_title_variant[productTitle + '::' + variantName];
        }
        if (entry && entry.helps_with) updatePills(entry.helps_with);
        updateDosage(variantId, data, variantName);
        updateFlavor(variantId, data, variantName);
        updateScienceCards(variantId, data);
      }
    });
  });
})();
